import './src/styles/layout.css'
import './src/styles/globals.scss'
import './src/utils/syntax-highlighting.scss'
